<template>
    <v-container fluid>
        <v-btn v-if="is_mobile" 
            @click="toggleViewOnMobile"
        >
            {{buttonLabel}}
        </v-btn>
        <PDFViewer v-bind="{ url: screen_data.document_url }"
            v-if="screen_data.document_url && (!is_mobile || mobile_view == 'document')" >
        </PDFViewer>
         <!-- Bottom Drawer (Fixed at Bottom) -->

        <v-navigation-drawer v-if="!is_mobile"
            class="drawer"
            app
            right
            clipped
            mobile-breakpoint="0" 
            width="800"
        >
            <OtherDocWorkflowDetail 
                :screen_data="screen_data"
                :list_component="list_component"
                :other_document_id="other_document_id"
                :companydb_id="companydb_id"
            />
        </v-navigation-drawer>
        <span v-else-if="is_mobile && mobile_view != 'document'">
            <OtherDocWorkflowDetail 
                :screen_data="screen_data"
                :list_component="list_component"
                :other_document_id="other_document_id"
                :companydb_id="companydb_id"
            />
        </span>
    </v-container>
    
</template>

<script>
import { VueOtherDocumentScreenData } from '@/modules/document/infra/VueOtherDocumentScreenData';
import PDFViewer from '../components/PDFViewer.vue'
import { mapGetters, mapState } from "vuex";
import {OtherDocDetailComponent} from '../modules/document/application/OtherDocDetailComponent'
import {ApiOtherDocumentRepository} from '../modules/document/infra/ApiOtherDocumentRepository'
import GeneralWorkflowDetail from '@/modules/document/infra/GeneralWorkflowDetail.vue'
import ExtractedDataComponent from '@/modules/document/infra/ExtractedDataComponent.vue'
import { document_components_factory } from "@/api/client";
import OtherDocWorkflowDetail from  "@/views/OtherDocWorkflowDetail.vue"

export default {
    name: 'OtherDocDetail',
    components: {
        PDFViewer,
        OtherDocWorkflowDetail,
    },
    data() {
        const screen_data = new VueOtherDocumentScreenData()
        const list_component = document_components_factory.get_list_component()
        return {
            screen_data: screen_data,
            other_doc_detail_component:null,
            bottomSheet: false,
            list_component: list_component,
            staff_mode: false,
            mobile_view: "document",
        }
    },
    
    props:{
        other_document_id:{
            type: [Number,String],
            required: true,
            default: null
        },
        companydb_id:{
            type: [Number,String],
            required: false,
            default: null
        }
    },
    async mounted() {
        this.other_doc_detail_component = new OtherDocDetailComponent(new ApiOtherDocumentRepository(), this.screen_data)
        await this.other_doc_detail_component.get_document_url(this.other_document_id)
        await this.other_doc_detail_component.find_by_id(this.other_document_id)
    },
    methods: {
        toggleViewOnMobile() { // swap values "document" and "detail"
            this.mobile_view = this.mobile_view == "document" ? "detail" : "document"
        }
    },
    computed: {
        ...mapGetters([
            "is_mobile",
        ]),
        ...mapGetters({
            userData: 'me/userData',
        }),
        buttonLabel(){
            return this.mobile_view == "document" ? "Ver detalle" : "Ver documento"
        },
    },
}

</script>


<style scoped>
.bottom-drawer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #ffffff;
}

.v-container {
  padding-bottom: 80px; /* Adjust based on the height of the drawer */
}
</style>